import { handleActions } from 'redux-actions'
import { actions } from '../actions/reports'
import { tr } from '../../helpers/languages'

const defaultState = {
    reports: undefined,
    currentReport: undefined,
    no_reports: false,
    no_reports_text: ""
}

const resetReports = (_state, _action) => {
    return defaultState
}

const setCurrentReport = (state, action) => {
    return { ...state, currentReport: action.payload }
}

const setReports = (state, action) => {
    return { ...state, reports: action.payload }
}

const setNoReports = (state, action) => {
    return { ...state, no_reports: action.payload }
}

const setNoReportsText = (state, action) => {
    var text = ""
    if (action.payload === 200){
        text = tr('FEEL_DATA_REPORT_NOT_YET')
    }
    else if (action.payload === 400){
        text = tr('FEEL_DATA_REPORT_NOT_EIGIBLE')
    }
    else{
        text = tr('FEEL_DATA_REPORT_ERROR')
    }
    return { ...state, no_reports_text: text }
}

export default handleActions({
    [actions.resetReports]: resetReports,
    [actions.setCurrentReport]: setCurrentReport,
    [actions.setReports]: setReports,
    [actions.setNoReports]:setNoReports,
    [actions.setNoReportsText]:setNoReportsText
}, defaultState)



// WEBPACK FOOTER //
// ./src/store/reducers/reports.js